import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bfe05ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "login-page",
  class: "page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center horizontal-center intro" }, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "input-section"
}
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"padding-bottom":"25px"} }, "Login", -1))
const _hoisted_6 = {
  class: "form-field",
  style: {"margin":"16px 0px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_9 = { class: "form-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "forgot-password" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Forgot password?")
const _hoisted_14 = { class: "form-field left-align" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Next ")
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["onSubmit"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please enter the code sent to your email", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Token", -1))
const _hoisted_22 = { class: "form-field left-align" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Log In ")

import api from "@virgodev/bazaar/functions/api";
// import { Capacitor } from "@capacitor/core";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "@/store";
import { ref } from "vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
// import scrollToFirstError from "@/methods/scroll_to_first_error";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tokenInput = ref(false);
const router = useRouter();
const route = useRoute();
const store = useStore();

const formFields = ref({
  email: "",
  password: "",
  deviceToken: "",
});

const formErrors = ref<Record<string, string[]>>({});

const formSubmitting = ref(false);

async function submitForm() {
  formErrors.value = {};
  formSubmitting.value = true;

  const responseData = await api({
    url: "users/login/",
    method: "POST",
    json: formFields.value,
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    store.logIn(responseData.body);
    router.push(
      typeof route.query.next === "string" ? route.query.next : { name: "Home" }
    );
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your connection and try again.",
      ],
    };
  }
}

async function generateToken() {
  formSubmitting.value = true;

  const responseData = await api({
    url: "two_factor/device_check/",
    method: "POST",
    json: formFields.value,
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    if (responseData.body.id) {
      store.logIn(responseData.body);
      router.push(
        typeof route.query.next === "string"
          ? route.query.next
          : { name: "Home" }
      );
    }
  } else if (responseData.status === 201) {
    if (responseData.body.device) {
      tokenInput.value = true;
      formErrors.value = {};
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your connection and try again.",
      ],
    };
  }
}

// async function getFacilityInfo() {
//   const responseData = await api({
//     url: "facility/",
//     method: "GET",
//   });
//   if (responseData.status === 200) {
//     store.facilityInfo(responseData.body);
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (formErrors.value.non_field_errors !== undefined)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 0,
          variant: "danger",
          class: "js-form-error",
          dismissible: "",
          onDismissed: _cache[0] || (_cache[0] = ($event: any) => (formErrors.value = {}))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!tokenInput.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(generateToken, ["prevent"])
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.email) = $event)),
                class: _normalizeClass('email' in formErrors.value ? 'is-invalid' : ''),
                type: "email",
                required: ""
              }, null, 2), [
                [_vModelText, formFields.value.email]
              ]),
              ('email' in formErrors.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(formErrors.value.email[0]), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.password) = $event)),
                class: _normalizeClass('password' in formErrors.value ? 'is-invalid' : ''),
                type: "password",
                required: ""
              }, null, 2), [
                [_vModelText, formFields.value.password]
              ]),
              ('password' in formErrors.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(formErrors.value.password[0]), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_RouterLink, { to: { name: 'password_reset' } }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                disabled: formSubmitting.value,
                type: "submit",
                class: "btn btn-gray"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  (formSubmitting.value)
                    ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_15)
            ])
          ], 40, _hoisted_4)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            _hoisted_20,
            _hoisted_21,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.deviceToken) = $event)),
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, formFields.value.deviceToken]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                disabled: formSubmitting.value,
                type: "submit",
                class: "btn btn-gray"
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  (formSubmitting.value)
                    ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_23)
            ])
          ], 40, _hoisted_19)
        ]))
  ]))
}
}

})